export const arraysAreEqualByKey = (arr1, arr2, key) => {
  if (!key) {
    key = 'id'
  }
  let firstArray = arr1.map(item => item[key])
  let secondArray = arr2.map(item => item[key])

  firstArray.sort((a, b) => a - b)
  secondArray.sort((a, b) => a - b)

  return JSON.stringify(firstArray) === JSON.stringify(secondArray)
}

/*
 * Compare two arrays
 * Works with string and int arrays
 */
export const arraysAreEqual = (arr1, arr2) => {
  // Make a copy in order to not change the reference
  let firstArray = JSON.parse(JSON.stringify(arr1))
  let secondArray = JSON.parse(JSON.stringify(arr2))

  firstArray.sort((a, b) => a - b)
  secondArray.sort((a, b) => a - b)
  return JSON.stringify(firstArray) === JSON.stringify(secondArray)
}
